import { CustomLink } from '@/components/custom-link/CustomLink';
import type { FooterBannerImage } from '@/shared/constant/footer-banner/FooterBanner';
import clsx from 'clsx';

export type BottomBannerImageProps = {
  value: FooterBannerImage;
  className?: string;
};

export function BottomBannerImage(props: BottomBannerImageProps) {
  const { value, className } = props;

  return (
    <div className={clsx('max-h-[180px] w-full', className)}>
      <CustomLink to={value.link}>
        <img className="max-h-[180px] max-w-full rounded-md" src={value.imageUrl} alt="" />
      </CustomLink>
    </div>
  );
}
